import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
// Per-route <head> (title, description, canonical, hreflang, JSON-LD) is managed by components/Seo.tsx.
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-8004" data-mp="269ttj4i04i7q" />);
}